import styled from '@emotion/styled';

import {HelpTooltip} from '@/components/HelpTooltip';

export const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto;
  grid-gap: 8px;

  ${HelpTooltip} {
    align-self: center;
  }
`;
